import { CartId } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

export const getPaymentMethod = (cartId: CartId) => (state: RootState) => {
  return state.quote.paymentMethod[cartId ?? ''] ?? {}
}
